module.exports = __webpack_public_path__ + "fonts/Sarabun-Light.3c1a731b.ttf";